import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SiteConfig {
  logo: string;
  theme: string;
  images: { logo: string, welcome: string, emailHeader: string, emailFooter: string };
  emails: { primary: string; secondary: string | null };
  phones: { primary: string; secondary: string | null };
  welcomeTitle: string;
  welcomeDescription: string;
}

interface GeneralStore {
  siteConfig: SiteConfig | null;
  isLoadingConfig: boolean;
  setSiteConfig: (siteConfig: SiteConfig) => void;
  setIsLoadingConfig: (isLoading: boolean) => void;
}

export const useGeneralStore = create<GeneralStore>()(
  persist(
    (set) => ({
      siteConfig: null,
      isLoadingConfig: true,
      setSiteConfig: (siteConfig: SiteConfig) => {
        set({ siteConfig });
        if (siteConfig?.theme) {
          document.body.classList.add(siteConfig?.theme);
        }
      },
      setIsLoadingConfig: (isLoadingConfig: boolean) => {
        set({ isLoadingConfig });
      },
    }),
    {
      name: 'site-config',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        siteConfig: state.siteConfig,
        // isLoadingConfig не сохраняется, всегда начинается с true
      }),
    }
  )
);
